import type { ColumnDef } from "@tanstack/react-table";
import type { WorkspaceSearchRow } from "../types/workspaceSearch";

export function useWorkspaceSearchColumns(): ColumnDef<WorkspaceSearchRow>[] {
    return [
        { accessorKey: "orgName", header: "org_name" },
        { accessorKey: "workspaceId", header: "workspace_id" },
        { accessorKey: "workspaceName", header: "workspace_name" },
        { accessorKey: "orgId", header: "org_id" },
        { accessorKey: "accountId", header: "account_id" },
        { accessorKey: "accountName", header: "account_name" },
    ];
}